import React from "react";

export default function VRIcon(props: any) {
  return (
    <svg
      width="72"
      height="40"
      viewBox="0 0 72 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70 27C70 28.103 69.103 29 68 29H66V17H68C69.103 17 70 17.897 70 19V27ZM64 34C64 36.206 62.206 38 60 38H12C9.794 38 8 36.206 8 34V12C8 9.794 9.794 8 12 8H60C62.206 8 64 9.794 64 12V34ZM18.6 5.2C21 2 22.065 2 24 2H48C49.935 2 51 2 53.4 5.2L54 6H18L18.6 5.2ZM6 29H4C2.897 29 2 28.103 2 27V19C2 17.897 2.897 17 4 17H6V29ZM68 15H66V12C66 8.686 63.313 6 60 6H56.5L55 4C52 0 50.209 0 48 0H24C21.791 0 20 0 17 4L15.5 6H12C8.687 6 6 8.686 6 12V15H4C1.791 15 0 16.791 0 19V27C0 29.209 1.791 31 4 31H6V34C6 37.313 8.687 40 12 40H60C63.313 40 66 37.313 66 34V31H68C70.209 31 72 29.209 72 27V19C72 16.791 70.209 15 68 15Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.2695 25.3569L30.0555 17.9999H27.5555L30.8125 27.9999H33.7275L36.9845 17.9999H34.4835L32.2695 25.3569Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.8467 22.7144H40.1317V20.1434H41.8467C42.4747 20.1434 42.9897 20.7004 42.9897 21.4284C42.9897 22.1574 42.4747 22.7144 41.8467 22.7144ZM45.2747 21.4284C45.2747 19.5284 43.7457 18.0004 41.8467 18.0004H37.8467V28.0004H40.1317V24.7144H41.2167L43.1027 28.0004H45.5607L43.4317 24.3284C44.5317 23.7724 45.2747 22.6574 45.2747 21.4284Z"
        fill="black"
      />
    </svg>
  );
}
